import { useState } from 'react';
import { ActivitySpeciesTypeClient, ActivitySpeciesTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useActivitySpeciesTypeApi = () => {
    const apiClient = new ActivitySpeciesTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ActivitySpeciesTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createActivitySpeciesType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ActivitySpeciesType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ActivitySpeciesTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateActivitySpeciesType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ActivitySpeciesType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getActivitySpeciesTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ActivitySpeciesType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchActivitySpeciesType(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ActivitySpeciesType');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteActivitySpeciesType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ActivitySpeciesType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};